import {
  getLaneById as getLaneByIdOp,
  getLaneWithInverse as getLaneWithInverseOp,
  getLaneWithLocations as getLaneWithLocationsOp,
} from '@gql/operations'
import { type GqlExecutor } from '@hopdrive/sdk-core'
import { LaneNotFoundError } from '../../errors/lane-errors'
import type { Lane, LaneWithInverse, LaneWithLocations } from '../../types'

export interface GetLaneParams {
  id: number
  includeInverse?: boolean
  includeLocations?: boolean
  required?: boolean
  executor?: GqlExecutor
}

export async function getLane(
  params: GetLaneParams
): Promise<Lane | LaneWithInverse | LaneWithLocations | null> {
  let lane: Lane | LaneWithInverse | LaneWithLocations | null = null

  if (params.includeLocations) {
    lane = (await getLaneWithLocationsOp(
      { id: params.id },
      { executor: params.executor }
    )) as LaneWithLocations | null
  } else if (params.includeInverse) {
    lane = (await getLaneWithInverseOp(
      { id: params.id },
      { executor: params.executor }
    )) as LaneWithInverse | null
  } else {
    lane = (await getLaneByIdOp(
      { id: params.id },
      { executor: params.executor }
    )) as Lane | null
  }

  if (!lane && params.required) {
    throw new LaneNotFoundError({ id: params.id })
  }

  return lane ?? null
}
